module.exports = __webpack_public_path__ + "img/45.49eb1107.png";